"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _reactIntl = require("react-intl");
var messages = (0, _reactIntl.defineMessages)({
  filterByTags: {
    "id": "searchPage_filterByTags",
    "defaultMessage": "Filter by Tags"
  },
  tagMatchesOnly: {
    "id": "searchPage_tagMatchesOnly",
    "defaultMessage": "Only results that match all tags will be shown."
  }
});
var _default = exports["default"] = messages;
//# sourceMappingURL=messages.js.map